import axios from 'axios';
import { Message } from 'element-ui';

const Axios = axios.create({ timeout: 15000 });

Axios.interceptors.request.use(
  (request) => {
    request.headers.contentType = 'application/json;charset=UTF-8';
    request.headers.client = window.require ? 'pc' : 'web';
    return request;
  },
  (error) => Promise.reject(error),
);
Axios.interceptors.response.use(
  (res) => res.data,
  (error) => {
    if (error && error.response) {
      const msg = error.response.data && error.response.data.errors[0].message ? `${error.response.data.errors[0].message}-${error.response.data.status}` : null;
      switch (error.response.status) {
        case 400:
          Message.error(msg || '请求错误-400');
          break;
        case 401:
          Message.error(msg || '访问失败，请重试-401');
          break;
        case 403:
          Message.error(msg || '拒绝访问-403');
          break;
        case 404:
          Message.error(msg || '请求失败-404');
          break;
        case 408:
          Message.error(msg || '请求超时-408');
          break;
        case 500:
          Message.error(msg || '服务器内部错误-500');
          break;
        case 501:
          Message.error(msg || '服务未实现-501');
          break;
        case 502:
          Message.error(msg || '无法连接服务器-502');
          break;
        case 503:
          Message.error(msg || '服务不可用-503');
          break;
        case 504:
          Message.error(msg || '连接服务器超时-504');
          break;
        case 505:
          Message.error(msg || 'HTTP版本不受支持-505');
          break;
        default:
      }
    }
    return Promise.reject(error);
  },
);

export default Axios;
